import { COLUMN_TYPE, FORMAT, MATCHING_TIME_PERIODS } from '../constants/generalConstants';
import { ColumnMetadataType, ReportPropsType } from '../types';

export function getDefaultReportProps(colsMetadata?: ColumnMetadataType[]): ReportPropsType {
    let result: ReportPropsType = {
        year: undefined,
        period: undefined,
        version: undefined,
        format: FORMAT.STANDARD,
        scale: undefined,
    };
    const reportColumn = colsMetadata?.find((x) => x.contentType === COLUMN_TYPE.REPORT);
    if (reportColumn && reportColumn.reportProps) {
        const reportProps = reportColumn.reportProps;

        let period = undefined;

        if (reportProps.period) {
            const reportPeriod = reportProps.period;
            const matchingPeriods = MATCHING_TIME_PERIODS.find((matchingPeriods) =>
                matchingPeriods.includes(reportPeriod)
            );

            if (matchingPeriods) {
                period = matchingPeriods.filter((p) => p !== reportPeriod)[0];
            }
        }
        result = { ...result, ...reportProps, period };
    }

    return result;
}
